/* 🤖 this file was generated by svg-to-ts */
export const matIconVerticalSplit: {
  name: 'vertical-split';
  data: string;
} = {
  name: 'vertical-split',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 13h8v2H3zm0 4h8v2H3zm0-8h8v2H3zm0-4h8v2H3zm16 2v10h-4V7h4m2-2h-8v14h8V5z"/></svg>`
};
